import { useState, useCallback } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("shweebum_token")}` },
});

export const useStoryArchitect = (projectId) => {
  const [knowledge, setKnowledge] = useState(null);
  const [analyzing, setAnalyzing] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const fetchStatus = useCallback(async () => {
    if (!projectId) return;
    try {
      const res = await axios.get(`${API}/api/story-architect/status/${projectId}`, authHeaders());
      setKnowledge(res.data.knowledge);
    } catch (e) {
      setKnowledge(null);
    }
  }, [projectId]);

  const analyze = useCallback(async (goal, placementHint, specificChapter) => {
    setAnalyzing(true);
    setError(null);
    setResult(null);
    try {
      const res = await axios.post(
        `${API}/api/story-architect/analyze`,
        {
          project_id: projectId,
          goal,
          placement_hint: placementHint || "",
          specific_chapter: specificChapter || null,
        },
        authHeaders()
      );
      setResult(res.data);
      if (res.data.knowledge) setKnowledge(res.data.knowledge);
    } catch (e) {
      setError(e.response?.data?.detail || "Story Architect couldn't analyze your story. Nothing was changed.");
    } finally {
      setAnalyzing(false);
    }
  }, [projectId]);

  const reset = useCallback(() => {
    setResult(null);
    setError(null);
  }, []);

  return { knowledge, fetchStatus, analyze, analyzing, result, error, reset };
};
